import WelcomeModalSchema from 'sitemodel/schema/components/WelcomeModalSchema'
import schemaToReactType from 'sitemodel/schema/util/schemaToReactType'
import schemaToTypeGuard from 'sitemodel/schema/util/schemaToTypeGuard'

export type WelcomeModalProps = schemaToReactType<typeof WelcomeModalSchema>

export const WelcomeModalTypeGuard = schemaToTypeGuard(WelcomeModalSchema)
